import {
  green1, purple1, red1, blue1, cyan1, yellow1, purple6, red6, green6, blue6, cyan6, yellow6,
} from '../../../../../shared/colours';
import {
  Assignee, AuthState, PublicUserDataV2, SDate, PrivateNote, PrivateNoteAttendeeV2,
} from '../../../../../shared/types/types';

export const emailTagsColors = [
  purple1, red1, green1, blue1, cyan1, yellow1,
];

export const emailTextColors = [
  purple6, red6, green6, blue6, cyan6, yellow6,
];

export const createSecretChatObject = (
  title: string,
  chatPathInRealtimeDb: string,
  members: PrivateNoteAttendeeV2[],
  meetingId: string,
  userIds: string[],
  created: SDate,
  updated: SDate,
  creator: PublicUserDataV2,
) => {
  const secretChat: PrivateNote = {
    title,
    chatPathInRealtimeDb,
    members,
    meetingId,
    userIds,
    created,
    updated,
    creator,
  };
  return secretChat;
};

export const authDataToAssignee = (authData: AuthState) => {
  const assignee: Assignee = {
    userId: authData.userId,
    photoUrl: authData.photoUrl,
    email: authData.email,
    name: `${authData.firstName} ${authData.lastName}`,
  };
  return assignee;
};
